import {lazy} from 'react';

export const TradedoublerConsent = lazy(() =>
  import('./TradedoublerConsent.eager').then(mod => ({
    default: mod.TradedoublerConsent,
  })),
);
